// Mock data for Shaw Transport and Logistics landing page

export const services = [
  {
    id: 1,
    title: "LTL (Less Than Truckload)",
    description: "Cost-effective shipping solutions for freight that doesn't require a full truck. Perfect for businesses looking to optimize their shipping costs.",
    icon: "Truck"
  },
  {
    id: 2,
    title: "Last Mile Delivery",
    description: "Fast and reliable final delivery to your customers' doorsteps. We ensure your packages arrive safely and on time.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Medical Deliveries",
    description: "Temperature-controlled, time-sensitive medical supply delivery with full compliance and tracking. Your critical medical items handled with care.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Automobile Parts",
    description: "Specialized handling and delivery of auto parts with secure packaging and expedited service options for urgent repairs.",
    icon: "Wrench"
  },
  {
    id: 5,
    title: "Regular Parcels",
    description: "Dependable parcel delivery for all your standard shipping needs. From small packages to larger items, we've got you covered.",
    icon: "Box"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    company: "MedSupply Solutions",
    role: "Logistics Manager",
    text: "Shaw Transport has been instrumental in our medical supply chain. Their reliability and attention to time-sensitive deliveries is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    company: "AutoParts Direct",
    role: "Operations Director",
    text: "We've been working with Shaw Transport for 3 years. Their handling of auto parts is professional, and delivery times are consistently excellent.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    company: "E-Commerce Plus",
    role: "CEO",
    text: "The last mile delivery service has transformed our customer satisfaction ratings. Fast, reliable, and professional service every time.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What areas do you service?",
    answer: "We provide comprehensive coverage across major metropolitan areas and surrounding regions. Contact us to confirm service availability in your specific location."
  },
  {
    id: 2,
    question: "How do I get a quote?",
    answer: "Simply fill out our contact form with your shipping details, or call us directly. We'll provide a competitive quote within 24 hours."
  },
  {
    id: 3,
    question: "Do you offer same-day delivery?",
    answer: "Yes! We offer same-day delivery for urgent shipments. Contact us before noon to inquire about same-day service availability."
  },
  {
    id: 4,
    question: "What makes your medical delivery service special?",
    answer: "Our medical delivery service includes temperature-controlled transport, real-time tracking, compliance with healthcare regulations, and trained drivers who understand the critical nature of medical supplies."
  },
  {
    id: 5,
    question: "Can I track my shipment?",
    answer: "Absolutely! All shipments come with real-time tracking. You'll receive tracking information as soon as your shipment is picked up."
  },
  {
    id: 6,
    question: "What size vehicles do you use?",
    answer: "Our fleet includes Mercedes Sprinter vans and Ford Transit vans, allowing us to handle various shipment sizes efficiently while maintaining flexibility for urban deliveries."
  }
];

export const companyStats = [
  {
    id: 1,
    value: "10,000+",
    label: "Deliveries Completed",
    icon: "Package"
  },
  {
    id: 2,
    value: "99.8%",
    label: "On-Time Delivery Rate",
    icon: "Clock"
  },
  {
    id: 3,
    value: "500+",
    label: "Happy Clients",
    icon: "Users"
  },
  {
    id: 4,
    value: "24/7",
    label: "Customer Support",
    icon: "Headphones"
  }
];

// Mock function to simulate form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Store in localStorage for demonstration
      const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      const newSubmission = {
        ...formData,
        id: Date.now(),
        timestamp: new Date().toISOString()
      };
      submissions.push(newSubmission);
      localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};
